<form [formGroup]="addressForm" class="white-form">
  <div class="row bg-block">
    <h3 class="h-sub-section col-12">{{ 'app_address_data_form_title' | translate | uppercase }}</h3>
    <div class="col">
      <div class="input-box">
        <label
          [for]="'roadType' + holder"
          [class.has-error]="addressForm?.controls['roadType']?.touched && !addressForm?.controls['roadType'].valid"
        >
          {{ 'app_address_data_form_type_road' | translate }}
        </label>
        <select [id]="'roadType' + holder" type="text" formControlName="roadType">
          <option value="" disabled>{{ 'app_address_data_form_select_type_road' | translate }}</option>
          <option *ngFor="let type of listRoadType$ | async" [value]="type?.code">{{ type?.code | translate }}</option>
        </select>
        <div class="error-content">
          @if (addressForm.controls['roadType'].touched && addressForm.controls['roadType'].hasError('required')) {
            <p class="has-error">
              {{ 'hipotecas_error_required' | translate }}
            </p>
          }
        </div>
      </div>
    </div>
    <div class="col">
      <div class="input-box">
        <label
          [for]="'roadName' + holder"
          [class.has-error]="addressForm?.controls['roadName']?.touched && !addressForm?.controls['roadName'].valid"
        >
          {{ 'app_address_data_form_road_name' | translate }}
        </label>
        <input
          [id]="'roadName' + holder"
          type="text"
          class="form-control"
          formControlName="roadName"
          [maxlength]="HTML_VALIDATORS?.maxLength?.roadName"
        />
        <div class="error-content">
          @if (addressForm.controls['roadName'].touched && addressForm.controls['roadName'].hasError('required')) {
            <p class="has-error">
              {{ 'hipotecas_error_required' | translate }}
            </p>
          }

          @if (addressForm.controls['roadName'].touched && addressForm.controls['roadName'].hasError('minlength')) {
            <p class="has-error">
              {{ 'hipotecas_error_minLength' | translate: { minLength: HTML_VALIDATORS?.minLength } }}
            </p>
          }
        </div>
      </div>
    </div>
    <div class="col">
      <div class="input-box">
        <label
          [for]="'roadNumber' + holder"
          [class.has-error]="addressForm?.controls['roadNumber']?.touched && !addressForm?.controls['roadNumber'].valid"
        >
          {{ 'app_address_data_form_number' | translate }}
        </label>
        <input
          [id]="'roadNumber' + holder"
          type="text"
          class="form-control"
          formControlName="roadNumber"
          [maxlength]="HTML_VALIDATORS?.maxLength?.roadNumber"
        />
      </div>
    </div>
    <div class="col">
      <div class="input-box">
        <label
          [for]="'floor' + holder"
          [class.has-error]="addressForm?.controls['floor']?.touched && !addressForm?.controls['floor'].valid"
        >
          {{ 'app_address_data_form_floor' | translate }}
        </label>
        <input
          [id]="'floor' + holder"
          type="text"
          class="form-control"
          formControlName="floor"
          [maxlength]="HTML_VALIDATORS?.maxLength?.floor"
        />
      </div>
    </div>
    <div class="col">
      <div class="input-box">
        <label
          [for]="'doorway' + holder"
          [class.has-error]="addressForm?.controls['doorway']?.touched && !addressForm?.controls['doorway'].valid"
        >
          {{ 'app_address_data_form_doorway' | translate }}
        </label>
        <input
          [id]="'doorway' + holder"
          type="text"
          class="form-control"
          formControlName="doorway"
          [maxlength]="HTML_VALIDATORS?.maxLength?.doorway"
        />
      </div>
    </div>

    <div class="col">
      <div class="input-box">
        <label
          [for]="'door' + holder"
          [class.has-error]="addressForm?.controls['door']?.touched && !addressForm?.controls['door'].valid"
        >
          {{ 'app_address_data_form_door' | translate }}
        </label>
        <input
          [id]="'door' + holder"
          type="text"
          class="form-control"
          formControlName="door"
          [maxlength]="HTML_VALIDATORS?.maxLength?.door"
        />
      </div>
    </div>
    <div class="col">
      <div class="input-box">
        <label
          [for]="'city' + holder"
          [class.has-error]="addressForm?.controls['city']?.touched && !addressForm?.controls['city'].valid"
        >
          {{ 'app_address_data_form_city' | translate }}
        </label>
        <input
          [id]="'city' + holder"
          type="text"
          class="form-control"
          formControlName="city"
          [ngClass]="{ error: addressForm.controls['city'].touched && addressForm.controls['city'].invalid }"
          [maxlength]="HTML_VALIDATORS.maxLength.cityName"
        />
        <div class="error-content">
          @if (addressForm.controls['city'].touched && addressForm.controls['city'].hasError('required')) {
            <p class="has-error">
              {{ 'hipotecas_error_required' | translate }}
            </p>
          }
        </div>
      </div>
    </div>

    <div class="col">
      <div class="input-box">
        <label
          [for]="'zip' + holder"
          [class.has-error]="addressForm?.controls['zip']?.touched && !addressForm?.controls['zip'].valid"
        >
          {{ 'app_address_data_form_postal_code' | translate }}
        </label>
        <input
          [id]="'zip' + holder"
          type="text"
          class="form-control"
          formControlName="zip"
          maxlength="5"
          [ngClass]="{ error: addressForm.controls['zip'].touched && addressForm.controls['zip'].invalid }"
        />
        <div class="error-content">
          @if (addressForm.controls['zip'].touched && addressForm.controls['zip'].hasError('required')) {
            <p class="has-error">
              {{ 'hipotecas_error_required' | translate }}
            </p>
          }

          @if (addressForm.controls['zip'].touched && addressForm.controls['zip'].hasError('pattern')) {
            <p class="has-error">
              {{ 'hipotecas_error_postal_code' | translate }}
            </p>
          }
        </div>
      </div>
    </div>
  </div>
</form>
